<script>
export default {
  name: 'BtnAdd',

  functional: true,

  props: {
    animate: {
      type: Boolean,
      default: false
    }
  },

  render: (h, { data, props }) => h('button', { ...data, class: { 'btn-add': true, 'btn-add--animate': props.animate } }, '+')
}
</script>

<style lang="stylus">
@import '~@/css/vars.styl'
@import '~@/css/animations.styl'
@import '~@/css/mixins.styl'

.btn-add
  width 50px
  height @width
  border-radius 50%
  background-color $accent
  color $white
  font-size 40px
  user-select none
  box-shadow $elevation
  cursor pointer
  transition $transition
  position relative
  hover()

  &--animate
    animate_pulse()
</style>
